import { render } from "./LoadingTestView.vue?vue&type=template&id=6a26f59e"
import script from "./LoadingTestView.vue?vue&type=script&lang=js"
export * from "./LoadingTestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__